import { YesNoMaybeSelection } from '@/models';

export default {
  name: 'yes-no-maybe-selector-required',
  validate: (value: YesNoMaybeSelection) => {
    return value !== null;
  },
};
